import { render, staticRenderFns } from "./BoardBanner.vue?vue&type=template&id=67799782&scoped=true"
import script from "./BoardBanner.vue?vue&type=script&lang=js"
export * from "./BoardBanner.vue?vue&type=script&lang=js"
import style0 from "./BoardBanner.vue?vue&type=style&index=0&id=67799782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67799782",
  null
  
)

export default component.exports